/** Mirrors `OKIS.Domain.Shared.Documents.AttachedDocumentType`. */
export enum AttachedDocumentType {
	Sanction = 1,
	DeficiencyRemediation = 2,
	Report = 3,
	Incident = 4,
}
